import React from 'react'
import { View, StyleSheet } from 'react-native'

const CheckoutProgressBar = ({ filled, total }) => {
	return (
		<View style={styles.container}>
			{Array.from({ length: total }).map((_, index) => (
				<View
					key={index}
					style={[styles.step, index < filled ? styles.filledStep : styles.unfilledStep]}
				>
					<View
						style={[
							styles.rectangle,
							index < filled
								? [styles.filledRectangle, { backgroundColor: global.orgColor }]
								: styles.unfilledRectangle,
						]}
					/>
					<View
						style={[
							styles.triangle,
							index < filled
								? [styles.filledTriangle, { borderLeftColor: global.orgColor }]
								: styles.unfilledTriangle,
						]}
					/>
				</View>
			))}
		</View>
	)
}

const styles = StyleSheet.create({
	container: {
		flexDirection: 'row',
		height: 20,
		alignItems: 'center',
	},
	step: {
		flex: 1,
		height: '100%',
		flexDirection: 'row',
		alignItems: 'center',
		marginRight: -15,
	},
	filledStep: {
		zIndex: 1,
	},
	unfilledStep: {
		zIndex: 0,
	},
	rectangle: {
		flex: 1,
		height: '100%',
	},
	filledRectangle: {
		backgroundColor: '#000000',
	},
	unfilledRectangle: {
		backgroundColor: '#E0E0E0',
	},
	triangle: {
		width: 0,
		height: 0,
		borderStyle: 'solid',
		borderTopWidth: 10,
		borderBottomWidth: 10,
		borderRightWidth: 0,
		borderLeftWidth: 7.5,
		position: 'relative',
		right: 0,
	},
	filledTriangle: {
		borderTopColor: 'transparent',
		borderBottomColor: 'transparent',
		borderLeftColor: '#000000',
	},
	unfilledTriangle: {
		borderTopColor: 'transparent',
		borderBottomColor: 'transparent',
		borderLeftColor: '#E0E0E0',
	},
})

export default CheckoutProgressBar
